
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none" viewBox="0 0 24 24"><circle cx="9.5" cy="5.5" r="1.5" fill="#000"/><circle cx="14.5" cy="5.5" r="1.5" fill="#000"/><circle cx="9.5" cy="11.5" r="1.5" fill="#000"/><circle cx="14.5" cy="11.5" r="1.5" fill="#000"/><circle cx="9.5" cy="17.5" r="1.5" fill="#000"/><circle cx="14.5" cy="17.5" r="1.5" fill="#000"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    